import {
  Box, Drawer, List, ListItemButton, ListItemIcon, ListItemText,
  Toolbar, Typography, IconButton, Divider, useMediaQuery, useTheme,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import PeopleIcon from '@mui/icons-material/People';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import PaymentsIcon from '@mui/icons-material/Payments';
import DevicesIcon from '@mui/icons-material/Devices';
import AssessmentIcon from '@mui/icons-material/Assessment';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import StorageIcon from '@mui/icons-material/Storage';
import SettingsIcon from '@mui/icons-material/Settings';
import HistoryIcon from '@mui/icons-material/History';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import EventIcon from '@mui/icons-material/Event';
import ScheduleIcon from '@mui/icons-material/Schedule';
import HomeWorkIcon from '@mui/icons-material/HomeWork';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { useLocation, useNavigate } from 'react-router-dom';
import { APP_NAME } from '../../config/constants';
import { useAuth } from '../../context/AuthContext';

export const DRAWER_WIDTH = 260;

const ALL_MENU = [
  { label: 'Dashboard', path: '/dashboard', Icon: DashboardIcon, key: 'dashboard' },
  { label: 'Employees', path: '/employees', Icon: PeopleIcon, key: 'employees' },
  { label: 'Attendance', path: '/attendance', Icon: AccessTimeIcon, key: 'attendance' },
  { label: 'Holidays', path: '/holidays', Icon: EventIcon, key: 'holidays' },
  { label: 'Shifts', path: '/shifts', Icon: ScheduleIcon, key: 'shifts' },
  { label: 'Leave', path: '/leave', Icon: EventAvailableIcon, key: 'leave' },
  { label: 'WFH', path: '/wfh', Icon: HomeWorkIcon, key: 'wfh' },
  { label: 'Payroll', path: '/payroll', Icon: PaymentsIcon, key: 'payroll' },
  { label: 'Salary Structure', path: '/salary', Icon: AccountBalanceIcon, key: 'salary' },
  { label: 'Loans', path: '/loans', Icon: AccountBalanceIcon, key: 'loans' },
  { label: 'Assets', path: '/assets', Icon: DevicesIcon, key: 'assets' },
  { label: 'Reports', path: '/reports', Icon: AssessmentIcon, key: 'reports' },
  { label: 'Notifications', path: '/notifications', Icon: NotificationsActiveIcon, key: 'notifications' },
  { label: 'Background Jobs', path: '/jobs', Icon: WorkHistoryIcon, key: 'jobs' },
  { label: 'Master Data', path: '/masters', Icon: StorageIcon, key: 'masters' },
  { label: 'Audit Logs', path: '/audit-logs', Icon: HistoryIcon, key: 'audit' },
  { label: 'Platform Tenants', path: '/platform/tenants', Icon: AdminPanelSettingsIcon, key: 'platform' },
  { label: 'Settings', path: '/settings', Icon: SettingsIcon, key: 'settings' },
];

export const Sidebar = ({ open, onClose, mobile }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { canAccessMenu, hasPermission } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const menuItems = ALL_MENU.filter((item) => canAccessMenu(item.key)).map((item) => {
    if (item.key === 'payroll' && !hasPermission('payroll.read') && hasPermission('payroll.view_own_payslip')) {
      return { ...item, label: 'My Payslips' };
    }
    return item;
  });

  const handleNavigate = (path) => {
    navigate(path);
    if (isMobile || mobile) onClose();
  };

  const drawer = (
    <>
      <Toolbar sx={{ px: 2, justifyContent: 'space-between', minHeight: 64 }}>
        <Typography variant="h6" fontWeight={700} color="primary" noWrap>{APP_NAME}</Typography>
        {(open || mobile) && (
          <IconButton onClick={onClose} size="small"><ChevronLeftIcon /></IconButton>
        )}
      </Toolbar>
      <Divider />
      <Box sx={{ overflow: 'auto', flex: 1, py: 1 }}>
        <List>
          {menuItems.map((item) => (
            <ListItemButton
              key={item.path}
              selected={location.pathname === item.path || location.pathname.startsWith(`${item.path}/`)}
              onClick={() => handleNavigate(item.path)}
              sx={{ mx: 1, borderRadius: 2, mb: 0.5 }}
            >
              <ListItemIcon sx={{ minWidth: 40 }}><item.Icon /></ListItemIcon>
              <ListItemText primary={item.label} primaryTypographyProps={{ fontSize: 14, fontWeight: 500 }} />
            </ListItemButton>
          ))}
        </List>
      </Box>
    </>
  );

  if (mobile) {
    return (
      <Drawer variant="temporary" open={open} onClose={onClose} ModalProps={{ keepMounted: true }}
        sx={{ '& .MuiDrawer-paper': { width: DRAWER_WIDTH } }}>
        {drawer}
      </Drawer>
    );
  }

  return (
    <Drawer variant="persistent" open={open}
      sx={{ width: open ? DRAWER_WIDTH : 0, flexShrink: 0, '& .MuiDrawer-paper': { width: DRAWER_WIDTH, boxSizing: 'border-box', borderRight: 1, borderColor: 'divider' } }}>
      {drawer}
    </Drawer>
  );
};
